// extracted by mini-css-extract-plugin
module.exports = {"body":"OEMCustSearch_body__1Qe0M","inputContainer":"OEMCustSearch_inputContainer__fmQ8c","input":"OEMCustSearch_input__tqtB6"};